/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Video_FiltersInputs */

const en_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Filters`)
};

const fr_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres vidéo`)
};

const de_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videofilter`)
};

const it_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri video`)
};

const ru_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеофильтры`)
};

const es_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de vídeo`)
};

const zh_cn2_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频滤镜`)
};

const ja_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオフィルター`)
};

const hi_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फ़िल्टर`)
};

const pt_pt2_options_quicktools_video_filters = /** @type {(inputs: Options_Quicktools_Video_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de vídeo`)
};

/**
* | output |
* | --- |
* | "Video Filters" |
*
* @param {Options_Quicktools_Video_FiltersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_video_filters = /** @type {((inputs?: Options_Quicktools_Video_FiltersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Video_FiltersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_video_filters(inputs)
	if (locale === "de") return de_options_quicktools_video_filters(inputs)
	if (locale === "it") return it_options_quicktools_video_filters(inputs)
	if (locale === "ru") return ru_options_quicktools_video_filters(inputs)
	if (locale === "es") return es_options_quicktools_video_filters(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_video_filters(inputs)
	if (locale === "ja") return ja_options_quicktools_video_filters(inputs)
	if (locale === "hi") return hi_options_quicktools_video_filters(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_video_filters(inputs)
	return en_options_quicktools_video_filters(inputs)
});